import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import GridGallery from '../../components/GridGallery'
import Inner from '../../components/Inner'
import { workApi } from '../../api'
import Title from '../../components/Title'

function Main() {
	const { t } = useTranslation()

	const limit = 6

	const [works, setWorks] = useState([])
	const [sort, setSort] = useState('created_at,desc')
	const [loading, setLoading] = useState(false)
	const [skip, setSkip] = useState(0)

	const getWorks = useCallback(async (sortValue) => {
		if (loading) return

		setLoading(true)
		let order_by = sortValue;
		let is_shown = true;
		const response = await workApi.list({ limit, skip, order_by, is_shown})
		setWorks((prevWorks) => skip === 0 ? response : [...prevWorks, ...response])
		setLoading(false)
	}, [loading, skip])

	const handleScroll = () => {
		const bottom = window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - window.innerHeight / 2
		if (bottom && !loading) {
			setSkip((prevSkip) => prevSkip + limit)
		}
	}

	// Reset works and skip when sort changes
    const handleSortChange = (newSort) => {
        setSort(newSort)
        setWorks([])
        setSkip(0)
    }

	useEffect(() => {
		getWorks(sort)
	}, [skip, sort])

	useEffect(() => {
		window.addEventListener('scroll', handleScroll)
		return () => window.removeEventListener('scroll', handleScroll)
	}, [loading])

	return (
		<>
			<Title>{t('All works')}</Title>
			<Inner>
				<GridGallery
					title={t('All works')}
					items={works}
					setSort={handleSortChange}
				/>
			</Inner>
		</>
	)
}

export default Main
